module.exports = __webpack_public_path__ + "static/media/yoga-landing-icon.98616968.svg";